
import React, { useEffect, useState } from 'react';
import { VerificationMethodSelect } from './VerificationMethodSelect';
import { VerifyCode } from './VerifyCode';

interface TwoFactorAuthFlowProps {
  email: string;
  phone: string;
  otp_created_at?: string;
  initialMethod?: 'sms' | 'email';
}

const TwoFactorAuthFlow: React.FC<TwoFactorAuthFlowProps> = ({ 
  email, 
  phone,
  otp_created_at,
  initialMethod
}) => {
  const [step, setStep] = useState<'select' | 'verify' | ''>('');//initialMethod ? 'verify' : 'select');
  const [method, setMethod] = useState<'sms' | 'email' | undefined>('email');
  const [otpCreatedAt, setOtpCreatedAt] = useState<string | undefined>(otp_created_at);
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState('');

  useEffect(() => {
    sendOtp('email');

  }, [])
  const getCSRFToken = (): string => {
    const token = document.querySelector('meta[name="csrf-token"]')?.getAttribute('content');
    return token || '';
  };

  const sendOtp = async (selectedMethod: 'sms' | 'email') => {
    setIsLoading(true);
    setError('');
    
    try {
      const response = await fetch('/two_factor_verification/send_otp', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/json',
          'X-CSRF-Token': getCSRFToken(),
        },
        credentials: 'same-origin',
        body: JSON.stringify({ method: selectedMethod })
      });

      const data = await response.json();
      
      if (response.ok) {
        setMethod(selectedMethod);
        setOtpCreatedAt(data.created_at || new Date().toISOString());
        setStep('verify');
      } else {
        throw new Error(data.error || 'Failed to send OTP');
      }
    } catch (err) {
      const errorMessage = err instanceof Error ? err.message : 'Failed to send OTP';
      setError(errorMessage);
      throw err; // Re-throw so the calling component can handle it
    } finally {
      setIsLoading(false);
    }
  };

  const handleMethodSelected = async (selectedMethod: 'sms' | 'email') => {
    try {
      await sendOtp(selectedMethod);
    } catch (err) {
      // Error is already set in sendOtp
      console.error('Failed to send OTP:', err);
    }
  };

  const handleResend = async () => {
    if (!method) return;
    
    try {
      await sendOtp(method);
      setError(''); // Clear any previous errors
    } catch (err) {
      // Error is already set in sendOtp
      console.error('Failed to resend OTP:', err);
    }
  };

  const handleChangeMethod = () => {
    setStep('select');
    setMethod(undefined);
    setOtpCreatedAt(undefined);
    setError('');
  };

  const handleVerificationSuccess = () => {
    // You can customize this behavior
    window.location.href = '/';
  };

  if (step === 'select') {
    return (
      <VerificationMethodSelect
        email={email}
        phone={phone}
        onSuccess={handleMethodSelected}
        onError={setError}
        isLoading={isLoading}
        error={error}
      />
    );
  }

  if (step === 'verify') {
    return (
      <VerifyCode
        method={method!}
        contactInfo={method === 'sms' ? phone : email}
        createdAt={otpCreatedAt}
        onSuccess={handleVerificationSuccess}
        onResend={handleResend}
        onChangeMethod={handleChangeMethod}
      />
    );
  }
  return <></>;
};

export default TwoFactorAuthFlow;